import { classEnum } from "./base";

export const PaymentMethodEnum = new (class extends classEnum([
    {
        label: "Tunai",
        value: "C",
    },
    {
        label: "Transfer",
        value: "X",
    },
    {
        label: "Agen",
        value: "D",
    },
    {
        label: "Lainnya",
        value: "O",
    },
]) {
    public get valuesCreate() {
        return this.values.filter((v) => v === "C" || v === "X");
    }

    public get selectCreate() {
        return this.select.filter((v) => v.value === "C" || v.value === "X");
    }

    public get ValuesCreate(): this["valuesCreate"][number] {
        throw new Error("ValuesCreate can't be used as a value");
    }

    public get valuesDirect() {
        return this.values.filter((v) => v !== "D");
    }

    public get selectDirect() {
        return this.select.filter((v) => v.value !== "D");
    }

    public get ValuesDirect(): this["valuesDirect"][number] {
        throw new Error("ValuesDirect can't be used as a value");
    }
})();

export namespace PaymentMethodEnum {
    export type Labels = (typeof PaymentMethodEnum)["labels"][number];
    export type Values = (typeof PaymentMethodEnum)["values"][number];
    export type ValuesCreate = (typeof PaymentMethodEnum)["valuesCreate"][number];
    export type ValuesDirect = (typeof PaymentMethodEnum)["valuesDirect"][number];
}
